import { Injectable } from "@angular/core";
import { RefreshTokenRequestBodyFactoryService } from "./refresh-token-request-body-factory.service";
import { RefreshTokenRequestHeadersFactoryService } from "./refresh-token-request-headers-factory.service";
import { RefreshTokenConfigurationService } from "../../configuration/auth/refresh-token/refresh-token-configuration.service";
import { AuthModule } from "../auth.module";
import { AuthorityConfigurationService } from "../../configuration/auth/authority/authority-configuration.service";

@Injectable({
  providedIn: AuthModule,
})
export class RefreshTokenRequestService {
  get refreshTokenConfiguration() {
    return this.refreshTokenConfigurationService.configuration;
  }

  get path() {
    return this.refreshTokenConfiguration.path;
  }

  get addSuperBatmanHeader() {
    if (this.authorityConfiguration) {
      return this.authorityConfiguration.addSuperBatmanHeader;
    } else {
      return false;
    }
  }

  get authorityConfiguration() {
    return this.getLocalAuthorityConfiguration();
  }

  constructor(
    private refreshTokenRequestBodyFactoryService: RefreshTokenRequestBodyFactoryService,
    private refreshTokenRequestHeadersFactoryService: RefreshTokenRequestHeadersFactoryService,
    private refreshTokenConfigurationService: RefreshTokenConfigurationService,
    private authorityConfigurationService: AuthorityConfigurationService
  ) {}

  getLocalAuthorityConfiguration() {
    return this.authorityConfigurationService.getLocalConfiguration();
  }

  createBody() {
    return this.refreshTokenRequestBodyFactoryService.createBody();
  }

  createHeaders() {
    return this.refreshTokenRequestHeadersFactoryService.createHeaders();
  }

  createOptions() {
    return {
      headers: this.createHeaders(),
      addInstanceIdHeader: false,
      addSuperBatmanHeader: this.addSuperBatmanHeader,
      addFeatureTrackingHeaders: false,
    };
  }
}
